import { useLocation, useParams } from 'react-router-dom'
import {
  useGetCallDetails,
  useGetUserPatient,
  useGetUserProfessional,
} from '@/modules/Users/queries/PatientQueries/Patient.queries'
import usePatientStore from '@/modules/Users/store/Patient/PatientStore'
import { useMemo } from 'react'

export const useCallDetails = () => {
  const callsId = useParams()
  const location = useLocation()
  const { callDetailsList } = useGetCallDetails(callsId?.id)

  const { patientId, professionalId, attendanceId, selectedPatient } =
    usePatientStore()
  const patientIdStore = String(patientId)
  const professionalIdStore = String(professionalId)

  const { getUserPatient } = useGetUserPatient(patientIdStore)
  const { getUserProfessional } = useGetUserProfessional(professionalIdStore)

  const isAppointmentHistoryRoute = useMemo(() => {
    return location.pathname.includes('/atendimento/historico-atendimentos')
  }, [location.pathname])

  const breadcrumbItems = useMemo(() => {
    if (isAppointmentHistoryRoute) {
      return [
        {
          id: 1,
          title: 'Histórico de agendamentos',
          active: false,
          path: '/atendimento/historico-atendimentos',
        },
        {
          id: 2,
          title: 'Detalhes do atendimento',
          active: false,
          path: `/atendimento/historico-atendimentos/detalhes-do-atendimento/${attendanceId}`,
        },
        {
          id: 4,
          title: 'Detalhes da chamada',
          active: true,
        },
      ]
    } else {
      return [
        {
          id: 1,
          title: 'Pacientes',
          path: '/usuario/pacientes',
          active: false,
        },
        {
          id: 2,
          title: 'Atendimentos',
          path: `/usuario/pacientes/atendimentos/${selectedPatient?.patientId}`,
          active: false,
        },
        {
          id: 3,
          title: 'Detalhes do atendimento',
          path: `/usuario/pacientes/atendimentos/detalhes-do-atendimento/${attendanceId}`,
          active: false,
        },
        {
          id: 4,
          title: 'Detalhes da chamada',
          active: true,
        },
      ]
    }
  }, [attendanceId, isAppointmentHistoryRoute, selectedPatient?.patientId])

  return {
    callDetailsList,
    getUserPatient,
    getUserProfessional,
    attendanceId,
    isAppointmentHistoryRoute,
    breadcrumbItems,
  }
}
